class TermsAndConditions extends HTMLElement {
    constructor() {
        super();      
      	this.Binds();
    }
  
    Binds () {
      var self = this;
      this.parentNode.querySelector('.cart__checkout-button.button').addEventListener("click", function (event) {
        console.log("123")
        if (!this.parentNode.querySelector('#enable_terms').checked) {
          event.preventDefault(); 
          
          var container = this.parentNode.querySelector('#enable_terms').parentNode.parentNode;
          
          if (container.querySelector('.error') == null) {
            var error = document.createElement('p');
            error.classList.add('error');
            error.innerHTML = "Dette felt er påkrævet";
            container.appendChild(error);
            
            if (!self.is_terms_bound) {
              this.parentNode.querySelector('#enable_terms').addEventListener('change', function () {
                if (container.querySelector('.error')) {
                  container.querySelector('.error').parentNode.removeChild(container.querySelector('.error'));
                }
              }, true);
              self.is_terms_bound = true;
            }
          }
        } 
      });
    }
}

customElements.define("terms-and-conditions", TermsAndConditions);